import axios from "axios";
import axiosConfig from "../config/axios";
import authorizationInterceptor from "./interceptors/authorization";
import { store } from "@/store";
import router from "@/router";

class Axios {
  axios: any;
  constructor() {
    this.axios = axios.create(axiosConfig);
    this.addRequestInterceptors();
    this.addResponseInterceptors();
  }

  addRequestInterceptors() {
    this.axios.interceptors.request.use(authorizationInterceptor);
  }

  addResponseInterceptors() {
    this.axios.interceptors.response.use(
      (response: any) => response,
      (error: any) => {
        if (
          error.response.status === 401 &&
          error.response.data["error"] === "Token invalid"
        ) {
          store.dispatch("logOff");
          router.push("/signin");
        } else if (
          error.response.status === 401 ||
          error.response.status === 403
        ) {
          router.push("/401");
        } else {
          return Promise.reject(error);
        }
      }
    );
  }
}

export default new Axios().axios;
